// extracted by mini-css-extract-plugin
export var center = "ConfirmDialog-module--center--f4047";
export var dialog = "ConfirmDialog-module--dialog--960e6";
export var left = "ConfirmDialog-module--left--b8731";
export var overlay = "ConfirmDialog-module--overlay--aa051";